const workReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default workReducer;